// extracted by mini-css-extract-plugin
export var content = "_p4-1";
export var fullScreen = "_p4-0";